import { render, staticRenderFns } from "./DeskTop.vue?vue&type=template&id=0f8cf7ee&scoped=true&"
import script from "./DeskTop.vue?vue&type=script&lang=js&"
export * from "./DeskTop.vue?vue&type=script&lang=js&"
import style0 from "./DeskTop.vue?vue&type=style&index=0&id=0f8cf7ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8cf7ee",
  null
  
)

export default component.exports